import { computed as s, getCurrentInstance as l, openBlock as d, createBlock as f, resolveDynamicComponent as u, mergeProps as p, withKeys as m, withCtx as k, renderSlot as C } from "vue";
import { createActionsProvider as _ } from "./design-system.es31.js";
/* empty css                    */
import v from "./design-system.es128.js";
const z = {
  name: "DsCard",
  props: {
    /**
     * The base elevation level for the card (this affects the hover, focus, and active states as well).
    */
    elevation: {
      type: String,
      default: "z1",
      options: ["z0", "z1", "z2", "z3", "z4", "z6", "z8", "z12"]
    },
    /**
     * The element type the card will render for its root element.
    */
    as: {
      type: String,
      default: "div",
      options: ["a", "div"]
    }
  },
  emits: ["click"],
  setup(n, { emit: r }) {
    const { containsEventTarget: o } = _(), t = s(() => {
      var e, c;
      return (c = (e = l()) == null ? void 0 : e.vnode.props) != null && c.onClick && n.as !== "a" ? {
        role: "button",
        tabindex: 0
      } : {};
    });
    function a(e) {
      o(e) ? e.preventDefault() : r("click", e);
    }
    function i(e) {
      n.as !== "a" && r("click", e);
    }
    return {
      attrs: t,
      handleClick: a,
      handleEnter: i
    };
  }
};
function h(n, r, o, t, a, i) {
  return d(), f(u(o.as), p(t.attrs, {
    class: ["ds-card", `elevation-${o.elevation}`],
    onClick: t.handleClick,
    onKeydown: m(t.handleEnter, ["enter"])
  }), {
    default: k(() => [
      C(n.$slots, "default", {}, void 0, !0)
    ]),
    _: 3
  }, 16, ["class", "onClick", "onKeydown"]);
}
const D = /* @__PURE__ */ v(z, [["render", h], ["__scopeId", "data-v-a750ff37"]]);
export {
  D as default
};
//# sourceMappingURL=design-system.es40.js.map
